// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var Organization$ReactHooksTemplate = require("../settings/organization.res.js");
var DeviseSignOut$ReactHooksTemplate = require("./DeviseSignOut.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../CurrentOrganization.res.js");

function emptyState(parent) {
  return {
          selected: parent,
          mobileOpen: false,
          commandOpen: false,
          searchQuery: ""
        };
}

function cx(classes) {
  return Belt_List.toArray(Belt_List.keep(classes, (function (s) {
                      return s !== "";
                    }))).join(" ");
}

function stopAnd(fn, $$event) {
  $$event.stopPropagation();
  return Curry._1(fn, undefined);
}

function anyPerm(hasPermission, perms) {
  return Belt_List.some(perms, Curry.__1(hasPermission));
}

var quickSurveyLinks = [
  {
    href: "/surveys/quick_survey",
    label: "New Quick Survey",
    icon: undefined
  },
  {
    href: "/quick_survey/report",
    label: "Reports",
    icon: undefined
  }
];

function strokeSvg(className, children) {
  return JsxRuntime.jsx("svg", {
              children: children,
              className: className,
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "1.75",
              viewBox: "0 0 24 24"
            });
}

function path(d) {
  return JsxRuntime.jsx("path", {
              d: d,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            });
}

function Header$Icons(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var cn = cx({
        hd: "saas-icon",
        tl: {
          hd: className,
          tl: /* [] */0
        }
      });
  switch (props.name) {
    case "campaigns" :
        return strokeSvg(cn, path("M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"));
    case "chevron" :
        return strokeSvg(cn, path("M19 9l-7 7-7-7"));
    case "close" :
        return strokeSvg(cn, path("M6 18L18 6M6 6l12 12"));
    case "comment" :
        return strokeSvg(cn, path("M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"));
    case "customer" :
        return strokeSvg(cn, path("M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"));
    case "dashboard" :
        return strokeSvg(cn, JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("rect", {
                                height: "9",
                                width: "7",
                                rx: "1.5",
                                x: "3",
                                y: "3"
                              }),
                          JsxRuntime.jsx("rect", {
                                height: "5",
                                width: "7",
                                rx: "1.5",
                                x: "14",
                                y: "3"
                              }),
                          JsxRuntime.jsx("rect", {
                                height: "9",
                                width: "7",
                                rx: "1.5",
                                x: "14",
                                y: "12"
                              }),
                          JsxRuntime.jsx("rect", {
                                height: "5",
                                width: "7",
                                rx: "1.5",
                                x: "3",
                                y: "16"
                              })
                        ]
                      }));
    case "download" :
        return strokeSvg(cn, path("M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"));
    case "help" :
        return strokeSvg(cn, path("M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"));
    case "insights" :
        return strokeSvg(cn, path("M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"));
    case "lock" :
        return strokeSvg(cn, JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("rect", {
                                height: "10",
                                width: "14",
                                rx: "2",
                                x: "5",
                                y: "11"
                              }),
                          JsxRuntime.jsx("path", {
                                d: "M8 11V8a4 4 0 018 0v3",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                              })
                        ]
                      }));
    case "menu" :
        return strokeSvg(cn, path("M4 6h16M4 12h16M4 18h16"));
    case "more" :
        return strokeSvg(cn, path("M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"));
    case "phone" :
        return strokeSvg(cn, path("M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"));
    case "quick" :
        return strokeSvg(cn, path("M13 10V3L4 14h7v7l9-11h-7z"));
    case "reports" :
        return strokeSvg(cn, path("M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"));
    case "search" :
        return strokeSvg(cn, path("M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"));
    case "settings" :
        return strokeSvg(cn, JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          path("M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"),
                          path("M15 12a3 3 0 11-6 0 3 3 0 016 0z")
                        ]
                      }));
    case "surveys" :
        return strokeSvg(cn, path("M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"));
    case "tickets" :
        return strokeSvg(cn, path("M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"));
    case "user" :
        return strokeSvg(cn, path("M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"));
    default:
      return JsxRuntime.jsx("span", {
                  className: cn
                });
  }
}

var Icons = {
  strokeSvg: strokeSvg,
  path: path,
  make: Header$Icons
};

function Header$IconButton(props) {
  var title = props.title;
  var href = props.href;
  var __className = props.className;
  var label = props.label;
  var className = __className !== undefined ? __className : "";
  var content = JsxRuntime.jsx(Header$Icons, {
        name: props.icon
      });
  if (href !== undefined) {
    return JsxRuntime.jsx("a", {
                children: content,
                "aria-label": label,
                className: cx({
                      hd: "saas-icon-btn",
                      tl: {
                        hd: className,
                        tl: /* [] */0
                      }
                    }),
                title: title,
                href: href
              });
  } else {
    return JsxRuntime.jsx("button", {
                children: content,
                "aria-label": label,
                className: cx({
                      hd: "saas-icon-btn",
                      tl: {
                        hd: className,
                        tl: /* [] */0
                      }
                    }),
                title: title,
                type: "button",
                onClick: props.onClick
              });
  }
}

var IconButton = {
  make: Header$IconButton
};

function Header$Brand(props) {
  var __orgName = props.orgName;
  var orgLogo = props.orgLogo;
  var orgName = __orgName !== undefined ? __orgName : "";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("a", {
                      children: JsxRuntime.jsx("img", {
                            className: "saas-brand__logo",
                            alt: "",
                            src: Image$ReactHooksTemplate.geckolystLogo
                          }),
                      "aria-label": "Home",
                      className: "saas-brand",
                      href: "/",
                      onClick: props.onClick
                    }),
                orgLogo !== undefined ? JsxRuntime.jsx("img", {
                        className: "saas-brand__org-logo",
                        title: orgName,
                        alt: "",
                        src: orgLogo
                      }) : JsxRuntime.jsx("span", {
                        "aria-hidden": true,
                        className: "saas-brand__divider"
                      })
              ]
            });
}

var Brand = {
  make: Header$Brand
};

function Header$NavItem(props) {
  var __extraClass = props.extraClass;
  var active = props.active;
  var label = props.label;
  var extraClass = __extraClass !== undefined ? __extraClass : "";
  return JsxRuntime.jsxs("a", {
              children: [
                JsxRuntime.jsx(Header$Icons, {
                      name: props.icon,
                      className: "saas-nav-item__icon"
                    }),
                JsxRuntime.jsx("span", {
                      children: label,
                      className: "saas-nav-item__label"
                    }),
                active ? JsxRuntime.jsx("span", {
                        "aria-hidden": true,
                        className: "saas-nav-item__indicator"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              "aria-label": label,
              className: cx({
                    hd: "saas-nav-item",
                    tl: {
                      hd: active ? "saas-nav-item--active" : "",
                      tl: {
                        hd: extraClass,
                        tl: /* [] */0
                      }
                    }
                  }),
              href: props.href,
              onClick: props.onClick
            });
}

var NavItem = {
  make: Header$NavItem
};

function Header$MenuLink(props) {
  var __isExternal = props.isExternal;
  var __className = props.className;
  var icon = props.icon;
  var className = __className !== undefined ? __className : "";
  var isExternal = __isExternal !== undefined ? __isExternal : false;
  return JsxRuntime.jsxs("a", {
              children: [
                icon !== undefined ? JsxRuntime.jsx(Header$Icons, {
                        name: icon,
                        className: "saas-dropdown-item__icon"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                props.label
              ],
              className: cx({
                    hd: "saas-dropdown-item",
                    tl: {
                      hd: className,
                      tl: /* [] */0
                    }
                  }),
              href: props.href,
              rel: isExternal ? "noreferrer" : undefined,
              target: isExternal ? "_blank" : undefined,
              onClick: props.onClick
            });
}

var MenuLink = {
  make: Header$MenuLink
};

function Header$HoverDropdown(props) {
  var __panelClass = props.panelClass;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var panelClass = __panelClass !== undefined ? __panelClass : "";
  return JsxRuntime.jsxs("div", {
              children: [
                Curry._1(props.trigger, undefined),
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: cx({
                            hd: "dropdown-list",
                            tl: {
                              hd: "saas-dropdown-panel",
                              tl: {
                                hd: panelClass,
                                tl: /* [] */0
                              }
                            }
                          })
                    })
              ],
              className: cx({
                    hd: "dropdown",
                    tl: {
                      hd: className,
                      tl: /* [] */0
                    }
                  })
            });
}

var HoverDropdown = {
  make: Header$HoverDropdown
};

function Header$NavList(props) {
  var onClick = props.onClick;
  var __extraClass = props.extraClass;
  var selected = props.selected;
  var extraClass = __extraClass !== undefined ? __extraClass : "";
  return Belt_Array.map(props.items, (function (item) {
                return JsxRuntime.jsx(Header$NavItem, {
                            href: item.href,
                            label: item.label,
                            icon: item.icon,
                            active: selected === item.id,
                            extraClass: extraClass,
                            onClick: onClick
                          }, item.id);
              }));
}

var NavList = {
  make: Header$NavList
};

function Header$QuickSurveyMenu(props) {
  var onClick = props.onClick;
  var __flat = props.flat;
  var __extraClass = props.extraClass;
  var extraClass = __extraClass !== undefined ? __extraClass : "";
  var flat = __flat !== undefined ? __flat : false;
  if (flat) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Header$Icons, {
                                name: "quick",
                                className: "saas-qs-group__icon"
                              }),
                          JsxRuntime.jsx("span", {
                                children: "Quick Survey"
                              })
                        ],
                        className: "saas-qs-group__label"
                      }),
                  Belt_Array.map(quickSurveyLinks, (function (link) {
                          return JsxRuntime.jsx(Header$MenuLink, {
                                      href: link.href,
                                      label: link.label,
                                      className: "saas-qs-group__link",
                                      onClick: onClick
                                    }, link.href);
                        }))
                ],
                className: cx({
                      hd: "saas-qs-group",
                      tl: {
                        hd: extraClass,
                        tl: /* [] */0
                      }
                    })
              });
  } else {
    return JsxRuntime.jsx(Header$HoverDropdown, {
                className: cx({
                      hd: "saas-nav-item",
                      tl: {
                        hd: "saas-nav-item--dropdown",
                        tl: {
                          hd: extraClass,
                          tl: /* [] */0
                        }
                      }
                    }),
                trigger: (function (param) {
                    return JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Header$Icons, {
                                        name: "quick",
                                        className: "saas-nav-item__icon"
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: "Quick Survey",
                                        className: "saas-nav-item__label"
                                      }),
                                  JsxRuntime.jsx(Header$Icons, {
                                        name: "chevron",
                                        className: "saas-nav-item__chevron"
                                      })
                                ],
                                "aria-label": "Quick Survey",
                                "aria-expanded": false,
                                className: "saas-nav-item__trigger",
                                role: "button",
                                tabIndex: 0
                              });
                  }),
                children: JsxRuntime.jsx("ul", {
                      children: Belt_Array.map(quickSurveyLinks, (function (link) {
                              return JsxRuntime.jsx("li", {
                                          children: JsxRuntime.jsx(Header$MenuLink, {
                                                href: link.href,
                                                label: link.label
                                              })
                                        }, link.href);
                            }))
                    })
              });
  }
}

var QuickSurveyMenu = {
  make: Header$QuickSurveyMenu
};

function Header$SettingsMenu(props) {
  var featureEnabled = props.featureEnabled;
  var hasPermission = props.hasPermission;
  var canManageUsers = Belt_List.some({
        hd: "ShowUser",
        tl: {
          hd: "AddUser",
          tl: {
            hd: "UpdateUser",
            tl: {
              hd: "DeleteUser",
              tl: /* [] */0
            }
          }
        }
      }, Curry.__1(hasPermission));
  var canManageRoles = Belt_List.some({
        hd: "ShowRole",
        tl: {
          hd: "AddRole",
          tl: {
            hd: "UpdateRole",
            tl: {
              hd: "DeleteRole",
              tl: /* [] */0
            }
          }
        }
      }, Curry.__1(hasPermission));
  var canManageKpi = Belt_List.some({
        hd: "ShowKpi",
        tl: {
          hd: "AddKpi",
          tl: {
            hd: "UpdateKpi",
            tl: {
              hd: "DeleteKpi",
              tl: /* [] */0
            }
          }
        }
      }, Curry.__1(hasPermission));
  var items = Belt_Array.keepMap([
        canManageUsers ? [
            "/users/all",
            "Users"
          ] : undefined,
        canManageRoles ? [
            "/roles/all",
            "Roles"
          ] : undefined,
        Curry._1(featureEnabled, "AdminPages") && canManageUsers ? [
            "/admin/view",
            "Admin Pages"
          ] : undefined,
        Curry._1(featureEnabled, "KpiManagement") && canManageKpi ? [
            "/users/kpi",
            "KPI Management"
          ] : undefined,
        Curry._1(props.flagEnabled, "GeneralSettingsUI") && Curry._1(hasPermission, "ManageSettings") ? [
            "/general_settings",
            "General Settings"
          ] : undefined
      ], (function (x) {
          return x;
        }));
  if (items.length === 0) {
    return null;
  } else {
    return JsxRuntime.jsx(Header$HoverDropdown, {
                className: "saas-icon-btn-wrap",
                panelClass: "saas-dropdown-panel--right",
                trigger: (function (param) {
                    return JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx(Header$Icons, {
                                      name: "settings"
                                    }),
                                "aria-label": "Settings",
                                "aria-expanded": false,
                                className: "saas-icon-btn",
                                title: "Settings",
                                type: "button"
                              });
                  }),
                children: JsxRuntime.jsx("ul", {
                      children: Belt_Array.map(items, (function (param) {
                              var href = param[0];
                              return JsxRuntime.jsx("li", {
                                          children: JsxRuntime.jsx(Header$MenuLink, {
                                                href: href,
                                                label: param[1]
                                              })
                                        }, href);
                            }))
                    })
              });
  }
}

var SettingsMenu = {
  make: Header$SettingsMenu
};

function Header$UserMenu(props) {
  var orgName = props.orgName;
  return JsxRuntime.jsxs(Header$HoverDropdown, {
              className: "saas-user-menu",
              panelClass: "saas-dropdown-panel--right",
              trigger: (function (param) {
                  return JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx("span", {
                                      children: JsxRuntime.jsx(Header$Icons, {
                                            name: "user",
                                            className: "saas-avatar__icon"
                                          }),
                                      "aria-hidden": true,
                                      className: "saas-avatar"
                                    }),
                                JsxRuntime.jsxs("span", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: orgName,
                                              className: "saas-user-meta__name",
                                              title: orgName
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: "Account",
                                              className: "saas-user-meta__role"
                                            })
                                      ],
                                      className: "saas-user-meta"
                                    }),
                                JsxRuntime.jsx(Header$Icons, {
                                      name: "chevron",
                                      className: "saas-user-trigger__chevron"
                                    })
                              ],
                              "aria-label": "User menu",
                              "aria-expanded": false,
                              className: "saas-user-trigger",
                              type: "button"
                            });
                }),
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: JsxRuntime.jsx(Header$Icons, {
                                    name: "user",
                                    className: "saas-avatar__icon"
                                  }),
                              "aria-hidden": true,
                              className: "saas-avatar saas-avatar--lg"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: orgName,
                                      className: "saas-dropdown-header__name",
                                      title: orgName
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Workspace account",
                                      className: "saas-dropdown-header__sub"
                                    })
                              ],
                              className: "saas-dropdown-header__text"
                            })
                      ],
                      className: "saas-dropdown-header"
                    }),
                JsxRuntime.jsx("div", {
                      className: "saas-dropdown-divider"
                    }),
                JsxRuntime.jsxs("ul", {
                      children: [
                        JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsx(Header$MenuLink, {
                                    href: "/users/profile",
                                    label: "Profile",
                                    icon: "user"
                                  })
                            }),
                        JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsx(Header$MenuLink, {
                                    href: "/users/update_password",
                                    label: "Change Password",
                                    icon: "lock"
                                  })
                            }),
                        JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsx(Header$MenuLink, {
                                    href: "https://geckolyst.com",
                                    label: "Help",
                                    icon: "help",
                                    isExternal: true
                                  })
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      className: "saas-dropdown-divider"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(DeviseSignOut$ReactHooksTemplate.make, {}),
                      className: "saas-dropdown-item saas-logout"
                    })
              ]
            });
}

var UserMenu = {
  make: Header$UserMenu
};

function Header$CommandPalette(props) {
  var onClose = props.onClose;
  var onQueryChange = props.onQueryChange;
  var query = props.query;
  var filtered = Belt_Array.keep(props.links, (function (item) {
          var q = query.toLowerCase();
          if (q === "") {
            return true;
          } else {
            return Js_string.includes(q, item.label.toLowerCase());
          }
        }));
  var handleClose = function (param) {
    Curry._1(onClose, undefined);
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      className: "saas-command__backdrop",
                      onClick: handleClose
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Header$Icons, {
                                      name: "search",
                                      className: "saas-command__search-icon"
                                    }),
                                JsxRuntime.jsx("input", {
                                      "aria-label": "Search navigation",
                                      className: "saas-command__input",
                                      autoFocus: true,
                                      placeholder: "Search navigation...",
                                      value: query,
                                      onKeyDown: (function (e) {
                                          if (e.key === "Escape") {
                                            return Curry._1(onClose, undefined);
                                          }
                                          
                                        }),
                                      onChange: (function (e) {
                                          Curry._1(onQueryChange, e.target.value);
                                        })
                                    }),
                                JsxRuntime.jsx("kbd", {
                                      children: "esc",
                                      className: "saas-search-trigger__kbd"
                                    })
                              ],
                              className: "saas-command__input-wrap"
                            }),
                        JsxRuntime.jsxs("ul", {
                              children: [
                                Belt_Array.map(filtered, (function (item) {
                                        return JsxRuntime.jsx("li", {
                                                    children: JsxRuntime.jsxs("a", {
                                                          children: [
                                                            JsxRuntime.jsx(Header$Icons, {
                                                                  name: item.icon,
                                                                  className: "saas-command__item-icon"
                                                                }),
                                                            JsxRuntime.jsx("span", {
                                                                  children: item.label
                                                                })
                                                          ],
                                                          className: "saas-command__item",
                                                          href: item.href,
                                                          onClick: handleClose
                                                        })
                                                  }, item.href);
                                      })),
                                filtered.length === 0 ? JsxRuntime.jsx("li", {
                                        children: "No matches",
                                        className: "saas-command__empty"
                                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                              ],
                              className: "saas-command__list"
                            })
                      ],
                      className: "saas-command__panel"
                    })
              ],
              "aria-label": "Command palette",
              "aria-modal": true,
              className: "saas-command",
              role: "dialog"
            });
}

var CommandPalette = {
  make: Header$CommandPalette
};

function Header(props) {
  var featureEnabled = props.featureEnabled;
  var flagEnabled = props.flagEnabled;
  var parent = props.parent;
  var match = React.useState(function (param) {
        return emptyState(parent);
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$1[0];
  var match$2 = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var organizationProfile = match$2[0];
  React.useEffect((function (param) {
          Curry._1(setState, (function (prev) {
                  return {
                          selected: parent,
                          mobileOpen: prev.mobileOpen,
                          commandOpen: prev.commandOpen,
                          searchQuery: prev.searchQuery
                        };
                }));
        }), [parent]);
  React.useEffect((function (param) {
          var handler = function ($$event) {
            var key = $$event.key;
            var meta = $$event.metaKey;
            var ctrl = $$event.ctrlKey;
            if ((meta || ctrl) && key.toLowerCase() === "k") {
              $$event.preventDefault();
              Curry._1(setState, (function (prev) {
                      return {
                              selected: prev.selected,
                              mobileOpen: prev.mobileOpen,
                              commandOpen: true,
                              searchQuery: ""
                            };
                    }));
            }
            if (key === "Escape") {
              return Curry._1(setState, (function (prev) {
                            return {
                                    selected: prev.selected,
                                    mobileOpen: false,
                                    commandOpen: false,
                                    searchQuery: ""
                                  };
                          }));
            }
            
          };
          document.addEventListener("keydown", handler);
          return (function (param) {
                    document.removeEventListener("keydown", handler);
                  });
        }), []);
  var closeMobile = function (param) {
    Curry._1(setState, (function (prev) {
            return {
                    selected: prev.selected,
                    mobileOpen: false,
                    commandOpen: prev.commandOpen,
                    searchQuery: prev.searchQuery
                  };
          }));
  };
  var openCommand = function (param) {
    Curry._1(setState, (function (prev) {
            return {
                    selected: prev.selected,
                    mobileOpen: prev.mobileOpen,
                    commandOpen: true,
                    searchQuery: ""
                  };
          }));
  };
  var closeCommand = function (param) {
    Curry._1(setState, (function (prev) {
            return {
                    selected: prev.selected,
                    mobileOpen: prev.mobileOpen,
                    commandOpen: false,
                    searchQuery: ""
                  };
          }));
  };
  var name = Organization$ReactHooksTemplate.name(organizationProfile);
  var orgName = name === "" ? "Workspace" : name;
  var isNcell = Organization$ReactHooksTemplate.name(organizationProfile) === "ncell";
  var orgLogo = Organization$ReactHooksTemplate.logo(organizationProfile);
  var canManageTickets = Curry._1(featureEnabled, "Tickets") && Curry._1(hasPermission, "ResolveTickets");
  var ticketsHref = canManageTickets && Curry._1(hasPermission, "ManageTickets") ? "/tickets/manage/all" : "/tickets/work/all";
  var primaryLinks = Belt_Array.keepMap([
        Curry._1(hasPermission, "ShowDashboard") && Curry._1(featureEnabled, "Dashboard") ? ({
              id: "dashboard",
              href: "/dashboard",
              label: "Dashboard",
              icon: "dashboard"
            }) : undefined,
        Curry._1(hasPermission, "ShowSurvey") || Curry._1(hasPermission, "DeleteSurvey") || Curry._1(hasPermission, "BuildSurvey") ? ({
              id: "surveys",
              href: "/projects/all",
              label: "Surveys",
              icon: "surveys"
            }) : undefined,
        Curry._1(hasPermission, "ShowCampaign") || Curry._1(hasPermission, "CreateCampaign") ? ({
              id: "campaigns",
              href: "/campaigns/all",
              label: "Campaigns",
              icon: "campaigns"
            }) : undefined,
        Curry._1(featureEnabled, "Reports") && Curry._1(hasPermission, "ShowReport") ? ({
              id: "reports",
              href: "/reports",
              label: "Reports",
              icon: "reports"
            }) : undefined,
        canManageTickets ? ({
              id: "tickets",
              href: ticketsHref,
              label: "Tickets",
              icon: "tickets"
            }) : undefined
      ], (function (x) {
          return x;
        }));
  var showQuickSurvey = Curry._1(featureEnabled, "QuickSurvey") && Curry._1(hasPermission, "ShowQuickSurvey");
  var secondaryLinks = Belt_Array.keepMap([
        Curry._1(flagEnabled, "Customer360View") ? ({
              id: "Customer 360",
              href: "/customer360",
              label: "Customer 360",
              icon: "customer"
            }) : undefined,
        Curry._1(hasPermission, "EditTextCategories") && Curry._1(flagEnabled, "ManualTextCategorization") ? ({
              id: "comment_categorization",
              href: "/category_edit",
              label: "Comment Categorisation",
              icon: "comment"
            }) : undefined,
        Curry._1(hasPermission, "AddUser") && Curry._1(flagEnabled, "TelephonicSurvey") ? ({
              id: "telephonic_surveys",
              href: "/campaigns/telephonic_surveys",
              label: "Telephonic Surveys",
              icon: "phone"
            }) : undefined,
        Curry._1(hasPermission, "AddUser") && Curry._1(flagEnabled, "InsightsDashboard") ? ({
              id: "insights",
              href: "/insights/dashboard",
              label: "Insights",
              icon: "insights"
            }) : undefined
      ], (function (x) {
          return x;
        }));
  var commandLinks = Belt_Array.concatMany([
        primaryLinks,
        showQuickSurvey ? [{
              id: "quick_survey",
              href: "/surveys/quick_survey",
              label: "Quick Survey",
              icon: "quick"
            }] : [],
        secondaryLinks,
        [{
            id: "downloads",
            href: "/downloads",
            label: "Downloads",
            icon: "download"
          }]
      ]);
  var renderSecondary = function (extraClass, flatQuick, onClick, param) {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  showQuickSurvey ? JsxRuntime.jsx(Header$QuickSurveyMenu, {
                          extraClass: extraClass,
                          flat: flatQuick,
                          onClick: onClick
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                  JsxRuntime.jsx(Header$NavList, {
                        items: secondaryLinks,
                        selected: state.selected,
                        extraClass: extraClass,
                        onClick: onClick
                      })
                ]
              });
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("header", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Header$IconButton, {
                                            label: "Open menu",
                                            icon: "menu",
                                            className: "saas-hamburger",
                                            onClick: (function (param) {
                                                Curry._1(setState, (function (prev) {
                                                        return {
                                                                selected: prev.selected,
                                                                mobileOpen: true,
                                                                commandOpen: prev.commandOpen,
                                                                searchQuery: prev.searchQuery
                                                              };
                                                      }));
                                              })
                                          }),
                                      JsxRuntime.jsx(Header$Brand, {
                                            orgLogo: orgLogo,
                                            orgName: orgName
                                          })
                                    ],
                                    className: "saas-navbar__left"
                                  }),
                              JsxRuntime.jsxs("nav", {
                                    children: [
                                      JsxRuntime.jsx(Header$NavList, {
                                            items: primaryLinks,
                                            selected: state.selected
                                          }),
                                      renderSecondary("saas-nav-item--lg-only", false, undefined, undefined),
                                      secondaryLinks.length !== 0 || showQuickSurvey ? JsxRuntime.jsx(Header$HoverDropdown, {
                                              className: "saas-more saas-nav-item--tablet-more",
                                              trigger: (function (param) {
                                                  return JsxRuntime.jsxs("button", {
                                                              children: [
                                                                JsxRuntime.jsx(Header$Icons, {
                                                                      name: "more",
                                                                      className: "saas-nav-item__icon"
                                                                    }),
                                                                JsxRuntime.jsx("span", {
                                                                      children: "More",
                                                                      className: "saas-nav-item__label"
                                                                    }),
                                                                JsxRuntime.jsx(Header$Icons, {
                                                                      name: "chevron",
                                                                      className: "saas-nav-item__chevron"
                                                                    })
                                                              ],
                                                              "aria-label": "More",
                                                              "aria-expanded": false,
                                                              className: "saas-nav-item saas-more__trigger",
                                                              type: "button"
                                                            });
                                                }),
                                              children: renderSecondary("saas-dropdown-nav-item", true, undefined, undefined)
                                            }) : null
                                    ],
                                    "aria-label": "Primary",
                                    className: "saas-nav saas-nav--desktop"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("button", {
                                            children: [
                                              JsxRuntime.jsx(Header$Icons, {
                                                    name: "search",
                                                    className: "saas-search-trigger__icon"
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: "Search",
                                                    className: "saas-search-trigger__text"
                                                  })
                                            ],
                                            "aria-label": "Search",
                                            className: "saas-search-trigger",
                                            title: "Search",
                                            type: "button",
                                            onClick: openCommand
                                          }),
                                      JsxRuntime.jsx(Header$IconButton, {
                                            label: "Search",
                                            icon: "search",
                                            className: "saas-search-icon-only",
                                            onClick: openCommand,
                                            title: "Search"
                                          }),
                                      JsxRuntime.jsx(Header$IconButton, {
                                            label: "Downloads",
                                            icon: "download",
                                            className: "saas-navbar__action-desktop-only",
                                            href: "/downloads",
                                            title: "Downloads"
                                          }),
                                      JsxRuntime.jsx(Header$SettingsMenu, {
                                            hasPermission: hasPermission,
                                            flagEnabled: flagEnabled,
                                            featureEnabled: featureEnabled
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Header$UserMenu, {
                                                  orgName: orgName
                                                }),
                                            className: "saas-navbar__action-desktop-only"
                                          })
                                    ],
                                    className: "saas-navbar__actions"
                                  })
                            ],
                            className: "saas-navbar__inner"
                          }),
                      className: cx({
                            hd: "saas-navbar",
                            tl: {
                              hd: "flex",
                              tl: {
                                hd: "flex-col",
                                tl: {
                                  hd: "fixed",
                                  tl: {
                                    hd: "w-full",
                                    tl: {
                                      hd: "z-50",
                                      tl: {
                                        hd: isNcell ? "saas-navbar--ncell bg-purple-900" : "saas-navbar--default bg-pinetree",
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }),
                      role: "banner"
                    }),
                JsxRuntime.jsx("div", {
                      "aria-hidden": !state.mobileOpen,
                      className: cx({
                            hd: "saas-drawer-overlay",
                            tl: {
                              hd: state.mobileOpen ? "saas-drawer-overlay--open" : "",
                              tl: /* [] */0
                            }
                          }),
                      onClick: closeMobile
                    }),
                JsxRuntime.jsxs("aside", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Header$Brand, {
                                      onClick: closeMobile,
                                      orgLogo: orgLogo,
                                      orgName: orgName
                                    }),
                                JsxRuntime.jsx(Header$IconButton, {
                                      label: "Close menu",
                                      icon: "close",
                                      onClick: closeMobile
                                    })
                              ],
                              className: "saas-drawer__header"
                            }),
                        JsxRuntime.jsxs("nav", {
                              children: [
                                JsxRuntime.jsx(Header$NavList, {
                                      items: primaryLinks,
                                      selected: state.selected,
                                      extraClass: "saas-drawer__link",
                                      onClick: closeMobile
                                    }),
                                renderSecondary("saas-drawer__link", true, closeMobile, undefined)
                              ],
                              "aria-label": "Mobile primary",
                              className: "saas-drawer__nav"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Header$MenuLink, {
                                      href: "/users/profile",
                                      label: "Profile",
                                      icon: "user",
                                      onClick: closeMobile
                                    }),
                                JsxRuntime.jsx(Header$MenuLink, {
                                      href: "/users/update_password",
                                      label: "Change Password",
                                      icon: "lock",
                                      onClick: closeMobile
                                    }),
                                JsxRuntime.jsx(Header$MenuLink, {
                                      href: "/downloads",
                                      label: "Downloads",
                                      icon: "download",
                                      onClick: closeMobile
                                    }),
                                JsxRuntime.jsx("div", {
                                      className: "saas-dropdown-divider"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(DeviseSignOut$ReactHooksTemplate.make, {}),
                                      className: "saas-dropdown-item saas-logout"
                                    })
                              ],
                              className: "saas-drawer__footer"
                            })
                      ],
                      "aria-hidden": !state.mobileOpen,
                      "aria-label": "Mobile navigation",
                      className: cx({
                            hd: "saas-drawer",
                            tl: {
                              hd: state.mobileOpen ? "saas-drawer--open" : "",
                              tl: /* [] */0
                            }
                          })
                    }),
                state.commandOpen ? JsxRuntime.jsx(Header$CommandPalette, {
                        query: state.searchQuery,
                        links: commandLinks,
                        onQueryChange: (function (value) {
                            Curry._1(setState, (function (prev) {
                                    return {
                                            selected: prev.selected,
                                            mobileOpen: prev.mobileOpen,
                                            commandOpen: prev.commandOpen,
                                            searchQuery: value
                                          };
                                  }));
                          }),
                        onClose: closeCommand
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ]
            });
}

var make = Header;

exports.emptyState = emptyState;
exports.cx = cx;
exports.stopAnd = stopAnd;
exports.anyPerm = anyPerm;
exports.quickSurveyLinks = quickSurveyLinks;
exports.Icons = Icons;
exports.IconButton = IconButton;
exports.Brand = Brand;
exports.NavItem = NavItem;
exports.MenuLink = MenuLink;
exports.HoverDropdown = HoverDropdown;
exports.NavList = NavList;
exports.QuickSurveyMenu = QuickSurveyMenu;
exports.SettingsMenu = SettingsMenu;
exports.UserMenu = UserMenu;
exports.CommandPalette = CommandPalette;
exports.make = make;
/* react Not a pure module */
